export default function (context: any) {
  function emitVoted(vote: any) {
    context.emit('support-vote-sent', vote);
  }

  return {
    emitVoted,
  };
}
